import { Table } from "react-bootstrap";
import {
  countCheckpointsForStageCategory,
  getEntityId,
  getEntityLabel,
} from "../utils/checkpointForm.utils";
import { getCategoryTypeName } from "../../../Categories/utils/category.utils";

const CheckpointCategoryList = ({
  categories = [],
  checkpoints = [],
  activeStageId = "",
  onSelectCategory,
  disabled = false,
}) => {
  if (!categories.length) {
    return (
      <p className="text-muted mb-0">
        No categories match the selected type for this rally.
      </p>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped hover className="mb-0 align-middle">
        <thead>
          <tr>
            <th>Category Name</th>
            <th style={{ width: 180 }}>Type Name</th>
            <th style={{ width: 150 }}>Checkpoint Count</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => {
            const categoryId = getEntityId(category);
            const count = countCheckpointsForStageCategory(
              checkpoints,
              activeStageId,
              categoryId
            );

            return (
              <tr
                key={categoryId}
                role="button"
                style={{ cursor: disabled ? "default" : "pointer" }}
                onClick={() => {
                  if (disabled || !categoryId) return;
                  onSelectCategory(category);
                }}
              >
                <td className="fw-semibold">
                  {getEntityLabel(category) || category.title || "-"}
                </td>
                <td>{getCategoryTypeName(category) || "-"}</td>
                <td>{count}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default CheckpointCategoryList;
